import * as React from 'react';
import { DropzoneAreaBase } from 'material-ui-dropzone';
import i18n from 'src/translation/i18n';
import Button from '@material-ui/core/Button';
import DeleteIcon from '@material-ui/icons/Delete';
import { HalfCircleSpinner } from 'react-epic-spinners';
import {
  createMuiTheme,
  MuiThemeProvider,
  withStyles
} from '@material-ui/core/styles';
import { Tooltip } from '@material-ui/core';
class ImageUpload extends React.Component<IImageUploadProps, any> {
  public render() {
    const theme = createMuiTheme({
      overrides: {
        MuiTooltip: {
          tooltip: {
            fontSize: '15px',
            color: 'black',
            backgroundColor: 'white'
          }
        }
      }
    });

    return (
      <>
        <div
          className={`col-12 ${
            this.props.DErrormsgshow &&
            this.props.part.Dcount < this.props.limit
              ? 'form-control-error-border-pic'
              : ''
          }`}
        >
          <div
            className={`btn-file ${
              this.props.DErrormsgshow && this.props.part.Dcount === 0
                ? 'error-pic'
                : ''
            }`}
          >
            {this.props.part.Dpictureofparts.length === this.props.max ? (
              ''
            ) : (
              <MuiThemeProvider theme={theme}>
                <DropzoneAreaBase
                  onAdd={(e: any) =>
                    this.props.handleDamagefileUpload(e, this.props.i)
                  }
                  filesLimit={
                    this.props.max -
                    (this.props.part.DshowUploadModal === false
                      ? 0
                      : this.props.part.Dpictureofparts.length)
                  }
                  acceptedFiles={['image/jpeg', 'image/png', 'image/jpg']}
                  fileObjects={[]}
                  maxFileSize={3146000}
                  showAlerts={['error', 'info']}
                  dropzoneText={`${i18n.t('damageClaim.dropzone')}`}
                  getDropRejectMessage={(file: any, type: any, size: any) => {
                    const errormessage =
                      file.size > 3146000
                        ? `${i18n.t('damageClaim.picture')} ${
                            file.name
                          } ${i18n.t('damageClaim.wasrejected')}`
                        : file.type !== 'image/jpeg' ||
                          'image/png' ||
                          'image/jpg'
                        ? `${i18n.t('damageClaim.picture')} ${
                            file.name
                          } ${i18n.t('damageClaim.typenotsupported')}`
                        : `${i18n.t('damageClaim.maxpic')} ${this.props.limit -
                            (this.props.part.DshowUploadModal === false
                              ? 0
                              : this.props.part.Dpictureofparts
                                  .length)} ${i18n.t('damageClaim.allowed')}`;
                    return errormessage;
                  }}
                  getFileLimitExceedMessage={() =>
                    `${i18n.t('damageClaim.maxpic')} ${this.props.max -
                      (this.props.part.DshowUploadModal === false
                        ? 0
                        : this.props.part.Dpictureofparts.length)} ${i18n.t(
                      'damageClaim.allowed'
                    )}`
                  }
                />
              </MuiThemeProvider>
            )}

            {this.props.DErrormsgshow &&
            this.props.part.Dcount < this.props.limit ? (
              <span className={`pic-error`}>
                <i>{i18n.t('damageClaim.damagepicturemsg')}</i>
              </span>
            ) : (
              ''
            )}
          </div>

          <div
            className={`${
              this.props.part.DshowUploadModal === true
                ? ' eachfile-wraper'
                : 'pic-list-remove'
            }`}
          >
            {this.props.part.Dpicofpart.map((name: any, index: any) => (
              <div className="each-file">
                <div className="pic-namewrapper">
                  <img
                    src={this.props.part.Dimagepreview[index].toString()}
                    className="pic-width"
                  />
                  {name}
                </div>

                <div className="w-10">
                  {this.props.part.Dpictureofparts.length >= 1 ? (
                    <>
                      {this.props.part.Dpictureofparts[index].Dspinner ===
                      'start' ? (
                        <HalfCircleSpinner
                          color="#0b4da2"
                          size={20}
                          style={{
                            marginRight: '8px',
                            display: 'inline-block',
                            padding: '0 10px 0 10px'
                          }}
                        />
                      ) : (
                        ''
                      )}
                    </>
                  ) : (
                    ''
                  )}
                </div>

                <div className="success-wraper">
                  {this.props.part.Dpictureofparts[index].Dspinner ===
                  'success' ? (
                    <div>
                      <MuiThemeProvider theme={theme}>
                        <Tooltip
                          title={i18n.t('partClaim.photouploaded')}
                          placement="bottom"
                        >
                          <i className="rpds rpds-check-circle success" />
                        </Tooltip>
                      </MuiThemeProvider>
                      <MuiThemeProvider theme={theme}>
                        <Tooltip
                          title={i18n.t('partClaim.photodelete')}
                          placement="bottom"
                        >
                          <button className="deleteicon" type="button">
                            <DeleteIcon
                              onClick={e =>
                                this.props.handleDeleteImage(
                                  index,
                                  this.props.part.Dpictureofparts[index]
                                    .Dimagecount,
                                  this.props.i,
                                  this.props.part.Dpicofpart[index]
                                )
                              }
                            />
                          </button>
                        </Tooltip>
                      </MuiThemeProvider>
                    </div>
                  ) : (
                    ''
                  )}

                  {this.props.part.Dpictureofparts[index].Dspinner ===
                  'failure' ? (
                    <>
                      <MuiThemeProvider theme={theme}>
                        <Tooltip
                          title={
                            this.props.part.Dpictureofparts[index].Dimgfail
                          }
                          placement="bottom"
                        >
                          <i className="rpds rpds-error" />
                        </Tooltip>
                      </MuiThemeProvider>
                      <MuiThemeProvider theme={theme}>
                        <Tooltip
                          title={i18n.t('partClaim.photoremove')}
                          placement="bottom"
                        >
                          <i
                            className="rpds rpds-close"
                            onClick={e =>
                              this.props.handleRemoveImage(index, this.props.i)
                            }
                          />
                        </Tooltip>
                      </MuiThemeProvider>
                    </>
                  ) : (
                    ''
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </>
    );
  }
}
export default ImageUpload;

interface IImageUploadProps {
  part: any;
  handleDamagefileUpload: (event: any, i: any) => void;
  handleDeleteImage: (index: any, delimgindex: any, i: any, part: any) => void;
  handleRemoveImage: (event: any, i: any) => void;
  i: any;
  limit: number;
  DErrormsgshow: boolean;
  max: number;
}
